import React, {useState, useEffect, useRef} from "react";
import {Form, Table, Input, DatePicker, Tooltip} from "antd";
import FormSearchFilter from "../../components/FormSearchFilter";
import APIService from "../../service/APIService";
import {priceFormat} from "../../utils";
import moment from "moment";
import getColumnSearchProps from "../../components/TableColumnSearchProps";

const {RangePicker} = DatePicker;
const dateFormatPicker = "DD-MM-YYYY HH:mm";


export default function UserMoneyLogPage() {
  const [dataTable, setDataTable] = useState([]);
  const [filterDate, setFilterDate] = useState({
    timeFrom: "",
    timeTo: "",
  });

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [filterText, setFilterText] = useState('');
  const [filterColumn, setFilterColumn] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const searchInput = useRef(null);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 140,
      sorter: (a, b) => a.id - b.id,
      align: "center",
    },
    {
      title: "USER",
      dataIndex: "player",
      key: "player",
      width: 140,
      align: "center",
      ...getColumnSearchProps(dataTable.length, "player", setFilterText, setFilterColumn, setCurrentPage, searchInput, searchText, setSearchText, searchedColumn, setSearchedColumn)
    },
    {
      title: "GAME",
      width: 140,
      dataIndex: "game",
      key: "game",

    },
    {
      title: "LOG",
      width: 250,
      dataIndex: "log",
      key: "log",
      ellipsis: {
        showTitle: false,
      },
      render: data => (
        <Tooltip placement="topLeft" title={data}>
          {data}
        </Tooltip>
      ),
      align: "center",
    },
    {
      title: "TIỀN",
      width: 160,
      dataIndex: "gold",
      key: "gold",
      render: (data) => priceFormat(data),

    },
    {
      title: "TIỀN THẮNG/THUA",
      dataIndex: "updateGold",
      key: "updateGold",
      sorter: (a, b) => a.updateGold - b.updateGold,
      render: (data) => priceFormat(data),
      width: 200,
    },
    {
      title: "CHI TIẾT",
      dataIndex: "detail",
      key: "detail",
      width: 250,
      ellipsis: {
        showTitle: false,
      },
      render: data => (
        <Tooltip placement="topLeft" title={data}>
          {data}
        </Tooltip>
      ),
    },
    {
      title: "LÚC",
      dataIndex: "time",
      key: "time",
      width: 200,
      align: "center",
      sorter: (a, b) => moment(a.time).valueOf() - moment(b.time).valueOf(),
      render: (data, data1, index) => (
        <p>{moment(data).format('DD-MM-YYYY HH:mm:ss')}</p>
      ),
    },
  ];

  async function getMoneyLogList(filter = {}, page = 1, size = 10) {
    try {
      let wherePlayerId = "";
      let filterWhere = [];
      if (filter["player"]) {
        wherePlayerId = ` player like '%${filter["player"]}%'`;
        filterWhere.push(wherePlayerId);
      }

      const data = await APIService.moneyLogList(filterDate.timeFrom, filterDate.timeTo, filterWhere.join(" AND "), page, size);
      if (data) {
        setDataTable(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  function onChangePage(page, _pageSize) {
    if (_pageSize !== pageSize) {
      setPageSize(_pageSize)
      setCurrentPage(1);
    } else if (page !== currentPage) {
      setCurrentPage(page)
    }
  }

  useEffect(() => {
    getMoneyLogList({
      [filterColumn]: filterText
    }, currentPage, pageSize).then();
  }, [filterDate, currentPage, pageSize, filterText]);

  return (
    <>
      <FormSearchFilter
        title="Fish Log Detail"
        initialValues={filterDate}
        onFormLayoutChange={(value) => {
          if (value.time) {
            setFilterDate({
              ...filterDate,
              timeFrom: moment(value.time[0]).format('YYYY-MM-DD'),
              timeTo: moment(value.time[1]).format('YYYY-MM-DD'),
            });
          } else {
            setFilterDate({timeFrom: "", timeTo: ""});
          }
        }}
      >
        <Form.Item label="Time" className="form-datepicker-filter" name="time">
          <RangePicker format={dateFormatPicker}/>
        </Form.Item>
      </FormSearchFilter>

      <Table columns={columns} rowKey={'id'} dataSource={dataTable} pagination={{
        position: ['top'], total: 1000, current: currentPage, onChange: onChangePage, defaultCurrent: 1
      }}/>
    </>
  );
}
